import { createRoot } from 'react-dom/client';
import Root from 'src/app/component';

const root = createRoot(document.querySelector('#root'));

root.render(<Root />);
